import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
interface NotificationData {
  name: string;
  location: string;
  price: string;
}
const customerData = [
// Female names
{
  name: 'Sarah',
  location: 'California'
}, {
  name: 'Emily',
  location: 'Texas'
}, {
  name: 'Jessica',
  location: 'Florida'
}, {
  name: 'Ashley',
  location: 'New York'
}, {
  name: 'Amanda',
  location: 'Colorado'
}, {
  name: 'Jennifer',
  location: 'Arizona'
}, {
  name: 'Michelle',
  location: 'Washington'
}, {
  name: 'Rachel',
  location: 'Oregon'
}, {
  name: 'Lauren',
  location: 'Nevada'
}, {
  name: 'Stephanie',
  location: 'Georgia'
}, {
  name: 'Nicole',
  location: 'North Carolina'
}, {
  name: 'Melissa',
  location: 'Virginia'
}, {
  name: 'Rebecca',
  location: 'Illinois'
}, {
  name: 'Laura',
  location: 'Pennsylvania'
}, {
  name: 'Katherine',
  location: 'Ohio'
}, {
  name: 'Elizabeth',
  location: 'Michigan'
}, {
  name: 'Christina',
  location: 'Tennessee'
}, {
  name: 'Samantha',
  location: 'Massachusetts'
}, {
  name: 'Victoria',
  location: 'Indiana'
}, {
  name: 'Natalie',
  location: 'Missouri'
},
// Male names
{
  name: 'Michael',
  location: 'California'
}, {
  name: 'David',
  location: 'Texas'
}, {
  name: 'James',
  location: 'Florida'
}, {
  name: 'Robert',
  location: 'New York'
}, {
  name: 'John',
  location: 'Colorado'
}, {
  name: 'Daniel',
  location: 'Arizona'
}, {
  name: 'Matthew',
  location: 'Washington'
}, {
  name: 'Christopher',
  location: 'Oregon'
}, {
  name: 'Andrew',
  location: 'Nevada'
}, {
  name: 'Joshua',
  location: 'Georgia'
}];
export function SalesNotification() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentNotification, setCurrentNotification] = useState<NotificationData | null>(null);
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);
  useEffect(() => {
    if (!isMobile) return;
    const generateNotification = (): NotificationData => {
      const randomCustomer = customerData[Math.floor(Math.random() * customerData.length)];
      return {
        name: randomCustomer.name,
        location: randomCustomer.location,
        price: '$24.99'
      };
    };
    const scheduleNextNotification = () => {
      const randomInterval = Math.floor(Math.random() * (12000 - 3000 + 1)) + 3000;
      return setTimeout(() => {
        setCurrentNotification(generateNotification());
        setIsVisible(true);
        setTimeout(() => {
          setIsVisible(false);
          scheduleNextNotification();
        }, 3000);
      }, randomInterval);
    };
    const initialTimeout = setTimeout(() => {
      setCurrentNotification(generateNotification());
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
        scheduleNextNotification();
      }, 3000);
    }, 2000);
    return () => {
      clearTimeout(initialTimeout);
    };
  }, [isMobile]);
  if (!isMobile || !currentNotification) return null;
  return <AnimatePresence data-id="element-253">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 20,
      scale: 0.95
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 10,
      scale: 0.98
    }} transition={{
      duration: 0.4,
      ease: [0.16, 1, 0.3, 1]
    }} className="fixed bottom-6 left-4 right-4 z-50 mx-auto max-w-sm" style={{
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
    }} data-id="element-254">
          <div className="bg-[#FBF9F6]/98 backdrop-blur-xl rounded-2xl shadow-soft-xl border border-[#E8905C]/20 p-3 flex items-center gap-3" data-id="element-255">
            <div className="flex-shrink-0" data-id="element-256">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/diiGjvJmFU5ZrzjoNmYu8Y/Generated_Image_October_12%2C_2025_-_8_47PM.png" alt="Embracing My Anxiety" className="w-12 h-12 rounded-lg object-cover" data-id="element-257" />
            </div>

            <div className="flex-1 min-w-0" data-id="element-258">
              <p className="text-xs text-[#3E4A55] font-medium mb-0.5" data-id="element-259">
                Recent purchase
              </p>
              <p className="text-sm text-[#1C2A3A] font-semibold leading-tight mb-1" data-id="element-260">
                {currentNotification.name} from {currentNotification.location}
              </p>
              <p className="text-xs text-[#3E4A55] leading-tight" data-id="element-261">
                purchased{' '}
                <span className="font-medium text-[#1C2A3A]" data-id="element-262">
                  Embracing My Anxiety
                </span>{' '}
                for{' '}
                <span className="font-semibold text-[#E8905C]" data-id="element-263">
                  {currentNotification.price}
                </span>
              </p>
            </div>

            <div className="flex-shrink-0" data-id="element-264">
              <div className="w-2 h-2 rounded-full bg-[#E8905C] animate-pulse" data-id="element-265" />
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}